export default __webpack_public_path__ + "static/fixed-buy-ggg-840e773094dc88bae10590228d5a74e0.png";